import { useEffect, useState } from "react";
import { fz } from "@/lib/fanzone";
import { Award, Lock } from "lucide-react";

export default function AchievementsWall({ unlocked = [] }) {
  const [all, setAll] = useState([]);

  useEffect(() => {
    fz.achievements().then(({ data }) => setAll(data || [])).catch(() => {});
  }, []);

  const has = new Set(unlocked);

  return (
    <div className="titans-card p-5 md:p-6" data-testid="fz-achievements">
      <div className="flex items-center justify-between mb-5">
        <div className="flex items-center gap-2">
          <Award size={16} className="text-titans-blue" />
          <span className="font-display text-xl uppercase">Achievements</span>
        </div>
        <span className="font-cond uppercase tracking-wider text-xs text-titans-silver">
          {unlocked.length} / {all.length}
        </span>
      </div>
      <div className="grid grid-cols-2 md:grid-cols-4 gap-3">
        {all.map((a) => {
          const got = has.has(a.key);
          return (
            <div
              key={a.key}
              data-testid={`fz-ach-${a.key}`}
              className={`rounded-lg border p-3.5 transition-all duration-200 ${
                got ? "border-titans-blue/50 bg-titans-blue/10" : "border-[#E2E8F0] bg-[#F8FAFC] opacity-60"
              }`}
            >
              <div className={`w-9 h-9 rounded-full flex items-center justify-center mb-2 ${got ? "bg-titans-navy text-white" : "bg-[#E2E8F0] text-titans-muted"}`}>
                {got ? <Award size={16} /> : <Lock size={14} />}
              </div>
              <div className="font-cond uppercase tracking-wide text-xs font-semibold">{a.name}</div>
              <div className="text-titans-silver text-[11px] font-body mt-0.5 leading-snug">{a.desc}</div>
            </div>
          );
        })}
      </div>
    </div>
  );
}
